import { createApp } from 'vue';
import { createPinia } from 'pinia';
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';

import Card from 'primevue/card';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Skeleton from 'primevue/skeleton';
import Chart from 'primevue/chart';
import Password from 'primevue/password';
import Dialog from 'primevue/dialog';
import Divider from 'primevue/divider';
import ToastService from 'primevue/toastservice';
import Toast from 'primevue/toast';
import InputMask from 'primevue/inputmask';
import DatePicker from 'primevue/datepicker';
import SelectButton from 'primevue/selectbutton';
import InputNumber from 'primevue/inputnumber';
import InputSwitch from 'primevue/inputswitch';
import ProgressSpinner from 'primevue/progressspinner';

import BrandLogo from '@/components/BrandLogo.vue';
import App from './App.vue';
import router from './router';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
/* import specific icon sets */
import { fas } from "@fortawesome/free-solid-svg-icons";
import { fab } from '@fortawesome/free-brands-svg-icons';

import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

/* DaLand brand fonts (self-hosted) - stacks defined in styles/base/fonts.css */
import '@fontsource/lexend/400.css';
import '@fontsource/lexend/500.css';
import '@fontsource/lexend/600.css';
import '@fontsource/lexend/700.css';
import '@fontsource/lexend/800.css';
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/400-italic.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';

import './styles/index.css'

import QRCodeVue3 from 'qrcode-vue3';

library.add(fas);
library.add(fab);

const app = createApp(App);

const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: '.p-dark',
            cssLayer: false
        }
    }
});
app.use(ToastService);

app.component('InputText', InputText);
app.component('Card', Card);
app.component('Button', Button);
app.component('Skeleton', Skeleton);
app.component('Chart', Chart);
app.component('Password', Password);
app.component('Dialog', Dialog);
app.component('InputMask', InputMask);
app.component('DatePicker', DatePicker);
app.component('SelectButton', SelectButton);
app.component('InputNumber', InputNumber);
app.component('Divider', Divider);
app.component('Toast', Toast);
app.component('QRCodeVue3', QRCodeVue3);
app.component('ProgressSpinner', ProgressSpinner);
app.component("font-awesome-icon", FontAwesomeIcon);
app.component('InputSwitch', InputSwitch);

app.component('BrandLogo', BrandLogo);

app.mount('#app');
